<template>
  <div>
    <LHeaderAbout>
      <LNav />
    </LHeaderAbout>
    <section class="container-fluid" id="to">
      <div class="row">
        <section class="container about-text">
          <div class="row">
            <div class="col-12 top">
              <h3>{{ t("about.h.title") }}</h3>
            </div>
          </div>
          <div class="row">
            <div class="container text">
              <div class="row">
                <div class="col-12 content">
                  <div class="row">
                    <div class="col-xl-12 info">
                      <div class="row">
                        <p>{{ t("about.texts.mainDescription") }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="borders b-d-left b-d-right b-d-bottom"></div>
              </div>
            </div>
          </div>
        </section>
        <section class="container-fluid photo gagra">
          <div class="text">
            <h3>{{ t("about.h.gagra.title") }}</h3>
            <p>{{ t("about.texts.gagra") }}</p>
          </div>
        </section>
        <section class="container about-text">
          <div class="row">
            <div class="col-12 top">
              <h3>{{ t("about.h.newAfon.title") }}</h3>
            </div>
          </div>
          <div class="row">
            <div class="container text">
              <div class="row">
                <div class="col-12 content">
                  <div class="row">
                    <div class="col-xl-12 info">
                      <div class="row">
                        <p>{{ t("about.texts.newAfon.description") }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="borders b-d-left b-d-right b-d-bottom"></div>
              </div>
            </div>
          </div>
        </section>
        <section class="container-fluid photo aphon">
          <div class="text">
            <h3>{{ t("about.h.newAfon.subtitle") }}</h3>
            <p>{{ t("about.texts.newAfon.details") }}</p>
          </div>
        </section>
        <section class="container about-text">
          <div class="row">
            <div class="col-12 top">
              <h3>{{ t("about.h.sukhum.title") }}</h3>
            </div>
          </div>
          <div class="row">
            <div class="container text">
              <div class="row">
                <div class="col-12 content">
                  <div class="row">
                    <div class="col-xl-12 info">
                      <div class="row">
                        <p>{{ t("about.texts.sukhum.description") }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="borders b-d-left b-d-right b-d-bottom"></div>
              </div>
            </div>
          </div>
        </section>
        <section class="container-fluid photo sukhum">
          <div class="text">
            <h3>{{ t("about.h.sukhum.subtitle") }}</h3>
            <p>{{ t("about.texts.sukhum.details") }}</p>
          </div>
        </section>
        <section class="container about-text">
          <div class="row">
            <div class="col-12 top">
              <h3>{{ t("about.h.ritsaLake.title") }}</h3>
            </div>
          </div>
          <div class="row">
            <div class="container text">
              <div class="row">
                <div class="col-12 content">
                  <div class="row">
                    <div class="col-xl-12 info">
                      <div class="row">
                        <p>{{ t("about.texts.ritsaLake.description") }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="borders b-d-left b-d-right b-d-bottom"></div>
              </div>
            </div>
          </div>
        </section>
        <section class="container-fluid photo mountains">
          <div class="text">
            <h3>{{ t("about.h.ritsaLake.subtitle") }}</h3>
            <p>{{ t("about.texts.ritsaLake.details") }}</p>
          </div>
        </section>
      </div>
    </section>
    <LFooter />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

// SEO optimization
useHead({
  title: 'Об Абхазии - История, культура и достопримечательности',
  meta: [
    {
      name: 'description',
      content: 'Узнайте всё об Абхазии: древние храмы, архитектурные памятники, природные достопримечательности, парки и горные ущелья. Информация о Гагре, Новом Афоне, Сухуме и озере Рица.'
    },
    {
      name: 'keywords',
      content: 'Абхазия, Сухум, Гагра, Новый Афон, озеро Рица, достопримечательности, путешествие, отдых, история Абхазии, курорты'
    },
    {
      property: 'og:title',
      content: 'Об Абхазии - История, культура и достопримечательности'
    },
    {
      property: 'og:description', 
      content: 'Узнайте всё об Абхазии: древние храмы, архитектурные памятники, природные достопримечательности, парки и горные ущелья. Информация о Гагре, Новом Афоне, Сухуме и озере Рица.'
    },
    {
      property: 'og:type',
      content: 'website'
    },
    {
      property: 'og:image',
      content: '/img/header-about.jpg'
    },
    {
      property: 'og:url',
      content: 'https://leonhotel.ru/about'
    }
  ]
})

definePageMeta({
  layout: 'default'
})
</script>

<i18n lang="json">
{
  "en": {
    "about": {
      "h": {
        "title": "About Abkhazia",
        "gagra": {
          "title": "City of Gagra"
        },
        "newAfon": {
          "title": "New Afon",
          "subtitle": "New Afon"
        },
        "sukhum": {
          "title": "Sukhum",
          "subtitle": "Heart of Abkhazia — Sukhum"
        },
        "ritsaLake": {
          "title": "Lake Ritsa",
          "subtitle": "Mountain Wonder"
        }
      },
      "texts": {
        "mainDescription": "Ancient temples and architectural monuments, parks with exotic vegetation, eucalyptus and boxwood groves, dolmens and caves with stalagmites, fantastically beautiful lakes and mountain gorges, the unique modern style of Sukhum and the uniqueness of New Afon. It's impossible to list all the attractions. They are better seen in person. Every year, the number of tourists wishing to visit Abkhazia grows. In addition to beach or wellness holidays, you can visit all the sights of Abkhazia and choose excursions to your taste.",
        "gagra": "Gagra, along with Pitsunda and New Afon, is one of the most famous resorts on the Abkhazian coast. This small cozy city is located on a narrow strip of coastal land stretching for 15 km along the seashore between the Psou and Bzyb rivers. Gagra is immersed in subtropical greenery, known for its picturesque embankment and beautiful parks, the most notable of which is the seaside park. Gagra is conventionally divided into new and old city. In New Gagra, life is bustling, and if you want to enjoy romance, head to Old Gagra, to the beautiful park with its tranquility and fountains.",
        "newAfon": {
          "description": "New Afon is one of the most popular places in Abkhazia, attracting tourists and pilgrims from around the world. It's a small cozy town located in the gorge of the Psyrtskha River at the foot of two picturesque mountains - Apsarskaya (345m above sea level) and Afon (500m above sea level). New Afon welcomes guests with a beautiful park rich in subtropical vegetation and ponds where swans live.",
          "details": "In New Afon, you can see several fascinating sites that are monuments of nature, history, and architecture. These include the New Afon Cave – a majestic creation of nature that amazes with its beauty and scale, a picturesque waterfall and the ancient temple of Simon the Canaanite, the New Afon Monastery complex on top of Mount Afon, the ancient Anakopia fortress on Mount Apsar, from whose tower you can see New Afon and most of the coast. A walking tour in the gorge of the Psyrtskha River is also interesting, where, according to legend, the holy apostle Simon the Canaanite prayed in a cell."
        },
        "sukhum": {
          "description": "The city of Sukhum (Abkhaz: Akua), capital of the Republic of Abkhazia, is one of the oldest cities in the world. It is comfortably spread out in a spacious bay and reliably protected by mountain ranges from the northeast, so the climate in Sukhum is milder than in other areas of the Black Sea coast. The average temperature of the coldest month – January – is +6 degrees, and the warmest – July – is +24 degrees. Autumn and winter here are warmer than on the French Riviera, and there are about 220 sunny days per year – more than in the Swiss resort of Davos.",
          "details": "Sukhum is the administrative, political and cultural center of Abkhazia, the country's main transport and industrial hub. It houses legislative and state governing bodies, the Academy of Sciences, Abkhazian State University, National Library, State Museum, Philharmonic, Abkhazian State TV and Radio Company, drama theaters (Abkhazian and Russian), colleges, schools and other educational and cultural institutions. Sukhum has several active temples of different confessions - an Orthodox cathedral, a Catholic church, a Lutheran church, a synagogue, and a mosque. The city has hotels and sanatoriums, numerous cafes and restaurants. The city's population is about 80 thousand people."
        },
        "ritsaLake": {
          "description": "Lake Ritsa occupies part of the Lashipse River valley. It was formed as a result of tectonic subsidence of the river valley at the junction of two geological structures: limestones and porphyrites. The lake is about 2000m long with a maximum depth of 150m. The water in the lake never freezes, with maximum water temperature recorded in August at +17 to +20 degrees. Only one fish species inhabits the lake - brook trout. Local hunters and shepherds had long known about the lake's existence, but it was first mapped by an unknown author in 1865.",
          "details": "Despite its small size, the lake influences the climate of the entire basin. The dominant mountain-valley winds blowing from the Lashipse River gorge to the Yupshara River gorge collide with local breezes. Sometimes on the lake, you can observe an unusually rare phenomenon when, in bad weather, torn clouds race back from the Yupshara gorge to Lashipse, barely touching the lake's surface."
        }
      }
    }
  },
  "ru": {
    "about": {
      "h": {
        "title": "Об Абхазии",
        "gagra": {
          "title": "Город Гагра"
        },
        "newAfon": {
          "title": "Новый Афон",
          "subtitle": "Новый Афон"
        },
        "sukhum": {
          "title": "Сухум",
          "subtitle": "Сердце Абхазии — Сухум"
        },
        "ritsaLake": {
          "title": "Озеро Рица",
          "subtitle": "Чудо гор"
        }
      },
      "texts": {
        "mainDescription": "Древние храмы и памятники архитектуры, парки с экзотической растительностью, эвкалиптовые и самшитовые рощи, дольмены и пещеры со сталагмитами, фантастические красивые озера и горные ущелья, неповторимый модерн Сухума и уникальность Нового Афона. Перечислить все достопримечательности невозможно. Их лучше увидеть. С каждым годом количество туристов, желающих посетить Абхазию, растет. Помимо пляжного или оздоровительного отдыха вы сможете посетить все достопримечательности Абхазии и подобрать экскурсии по Абхазии на свой вкус.",
        "gagra": "Гагра, наряду с Пицундой и Новым Афоном, один из самых известных курортов абхазского побережья. Небольшой уютный город расположен на узкой полоске приморской земли, протянувшейся на 15 км вдоль берега моря между реками Псоу и Бзыбь. Гагра вся утопает в субтропической зелени, она известна своей живописной набережной и прекрасными парками, наиболее примечательный из которых приморский парк. Гагра условно разделена на новый и старый город. В Новой Гагре жизнь бьет ключом, а если вам захочется насладиться романтикой, то отправляйтесь в Старую Гагру, в прекрасный парк с тишиной и фонтанами.",
        "newAfon": {
          "description": "Новый Афон - одно из самых популярных мест в Абхазии, куда устремляются туристы и паломники со всего света. Это маленький уютный городок, расположившийся в ущелье реки Псырцха у подножия двух живописных гор - Апсарской (345 м над уровнем моря) и Афонской (500 м над уровнем моря). Новый Афон встречает гостей прекрасным парком с богатой субтропической растительностью и прудами, в которых живут лебеди.",
          "details": "В Новом Афоне можно увидеть несколько интереснейших объектов, которые являются памятниками природы, истории и архитектуры. Это и Новоафонская пещера – величественное творение природы, поражающее воображение красотой и масштабом, живописный водопад и древний храм Симона Кананита, комплекс Новоафонского монастыря на вершине Афонской горы, древняя крепость Анакопия на Апсарской горе, с башни которой открывается вид на Новый Афон и большую часть побережья. Интересна будет и пешая прогулка в ущелье реки Псырцха, где в келье, согласно легенде, молился святой апостол Симон Кананит."
        },
        "sukhum": {
          "description": "Город Сухум (абхаз. Акуа), столица Республики Абхазия, один из древнейших городов мира. Он уютно раскинулся в просторной бухте, а с северо-востока надежно защищен горными хребтами, поэтому климат в Сухуме мягче, чем в других районах Черноморского побережья. Средняя температура самого холодного месяца – января – +6 градусов, а самого теплого – июля – +24 градуса. Осень и зима здесь теплее, чем на Французской Ривьере, а солнечных дней в году – их около 220 – больше, чем на швейцарском курорте Давосе.",
          "details": "Сухум – административный, политический и культурный центр Абхазии, главный транспортный и промышленный узел страны. Здесь находятся законодательные и государственные органы управления, функционируют Академия Наук, Абхазский госуниверситет, Национальная библиотека, Государственный музей, филармония, Абхазская государственная телерадиокомпания, драматические театры (абхазский и русский), колледжи, училища и другие образовательные и культурные учреждения. В Сухуме несколько действующих храмов разных конфессий - православный кафедральный собор, католический костел, лютеранская кирха, синагога, мечеть. В городе работают гостиницы и санатории, множество кафе и ресторанов. Население города – около 80 тысяч человек."
        },
        "ritsaLake": {
          "description": "Озеро Рица занимает часть долины реки Лашипсе. Оно образовалось в результате тектонического опускания долины реки на стыке двух геологических структур: известняков и порфиритов. Протяженность озера около 2000 м, наибольшая глубина - 150 м. Вода в озере никогда не замерзает, максимальная температура воды регистрируется в августе и составляет +17 - +20 градусов. В озере обитает один вид рыбы - ручьевая форель. Местные охотники и пастухи знали о существовании озера давно, но впервые оно было нанесено на карту неизвестным автором в 1865 году.",
          "details": "Несмотря на небольшие размеры, озеро оказывает влияние на климат всей котловины. Господствующие над ним горнодолинные ветры, дующие из ущелья р. Лашипсе в ущелье р. Юпшара, сталкиваются с местными бризами. Иногда на озере можно наблюдать необычайно редкое явление, когда в ненастье разорванные тучи низко, едва не задевая поверхность озера, мчатся обратно от ущелья Юпшары к Лашипсе."
        }
      }
    }
  }
}
</i18n>

<style scoped>
.about-text {
  margin-top: 50px;
  margin-bottom: 50px;
}
.top {
  flex: 0 0 calc(100% - 90px);
  border-left: 2px solid #d9ccaf;
  border-right: 2px solid #d9ccaf;
  border-top: 2px solid #d9ccaf;
  padding-left: 111px;
  padding-right: 111px;
  margin-left: 45px;
  margin-right: 45px;
  padding-bottom: 20px;
  text-align: center;
  position: relative;
  display: flex;
}
.top h3 {
  margin-top: -25px;
  font-family: "playfair";
  font-size: 40px;
  background-color: white;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 2px;
  line-height: 1;
  margin-left: auto;
  margin-right: auto;
}
.content {
  position: relative;
  padding-bottom: 35px;
  width: 100%;
}
.container .row {
  position: relative;
  z-index: 2;
}
.container .row .borders {
  position: absolute;
  left: 44px;
  right: 44px;
  bottom: 0;
  top: 0;
  z-index: 1;
}
.b-d-top {
  border-top: 2px solid #d9ccaf !important;
}
.b-d-bottom {
  border-bottom: 2px solid #d9ccaf !important;
}
.b-d-right {
  border-right: 2px solid #d9ccaf !important;
}
.b-d-left {
  border-left: 2px solid #d9ccaf !important;
}
.cont {
  position: relative;
  padding-left: 69px;
  margin-top: 32px;
}
.info p {
  width: 100%;
  font-family: "Lato";
  font-size: 20px;
  line-height: 27px;
  padding-left: 200px;
  padding-right: 200px;
  text-align: center;
}
.photo {
  height: 900px;
  position: relative;
}
.gagra {
  background-image: url("/img/gagra.png");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
}
.aphon {
  background-image: url("/img/aphon.png");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
}
.sukhum {
  background-image: url("/c3831e51c1271.png");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
}
.mountains {
  background-image: url("/img/mountains.png");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
}

.photo .text {
  position: absolute;
}
.photo.gagra .text {
  right: 75px;
  left: 50%;
  bottom: 75px;
  text-align: right;
}
.photo.aphon .text {
  right: 75px;
  left: 50%;
  bottom: 75px;
  text-align: right;
}
.photo.sukhum .text {
  right: 50%;
  left: 75px;
  top: 75px;
  text-align: left;
}
.photo.mountains .text {
  right: 50%;
  left: 75px;
  bottom: 75px;
  text-align: left;
}
.photo .text h3 {
  font-family: "playfair";
  font-size: 69px;
  color: white;
  margin-bottom: 30px;
  line-height:57px;
}
.photo .text p {
  color: white;
  width: 100%;
  margin: 0px;
  font-family: "Lato";
  font-size: 20px;
  line-height: 27px;
}
@media screen and (max-width: 1200px) {
  .top {
    flex: 0 0 calc(100% - 32px);
    padding-left: 0px;
    padding-right: 0px;
    margin-left: 16px;
    margin-right: 16px;
  }
  .top h3 {
    margin-top: -16px;
    font-family: "playfair";
    font-size: 28px;
    background-color: white;
    padding-left: 20px;
    padding-right: 20px;
    margin-bottom: 2px;
    line-height: 1;
    margin-left: auto;
    margin-right: auto;
  }
  .container .row .borders {
    position: absolute;
    left: 16px;
    right: 16px;
    bottom: 0;
    top: 0;
    z-index: 1;
  }
  .info p {
    width: 100%;
    font-family: "Lato";
    font-size: 18px;
    line-height: 27px;
    padding-left: 32px;
    padding-right: 32px;
    text-align: center;
  }
  .photo {
    display: flex;
    height: auto !important;
  }
  .photo .text {
    padding-right: 0px !important;
    padding-left: 0px !important;
    text-align: center !important;
    position: relative !important;
    margin: auto !important;
    right: 0px !important;
    left: 0px !important;
    top: auto !important;
    bottom: auto !important;
  }
  .photo .text h3 {
    font-family: "fairplay";
    font-size: 28px;
    color: white;
    margin-bottom: 16px;
    padding-left: 0px;
    padding-right: 0px;
  }
  .photo .text p {
    color: white;
    width: 100%;
    margin: 0px;
    font-family: "Lato";
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 30px;
  }
}
</style>

<style>
footer {
  margin-top: -1px;
}
</style>
